import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "JobOfferSubscribe" })
export default class JobOfferSubscribe extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public recaptchaId: number = 0;
    public formData: any = { jobArea: null, qualification: null, jobOfferCode: null };
    public jobAreas: any[] = [];
    public qualifications: any[] = [];
    public jobOfferInfoList: any[] = [];
    public validationErrors: any[] = [];
    public fileName: string = null;

    get jobOfferCode() {
        return this.$store.getters["workWithUsStore/jobOfferCode"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly recaptchaSiteKey: string;

    @Watch("jobOfferCode") onJobOfferCodeUpdate(newValue: string) {
        this.formData.jobOfferCode = newValue;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.Contacts_WorkWithUsData, null)).data;
        this.jobAreas = result.jobAreas;
        this.qualifications = result.qualifications;
        this.jobOfferInfoList = result.jobOfferInfoList;
    }

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.recaptcha.net/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public setRegistrationFileName() {
        let curriculumVitae = (<any>this).$refs.curriculumVitae;

        this.fileName = null;

        if (curriculumVitae.files.length !== 0 && curriculumVitae.files[0].name) {
            this.fileName = curriculumVitae.files[0].name;
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        let multipartData = new FormData();

        multipartData.append("curriculumVitae", (<any>this).$refs.curriculumVitae.files[0]);

        for (const key in this.formData) {
            if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
                if (this.formData[key]) {
                    multipartData.append(key, this.formData[key]);
                }
            }
        }

        this.recaptchaId = this.getWidgetId("JobOfferSubscribe");

        try {
            await Axios.post(this.routes.Contacts_WorkWithUs, multipartData, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse(this.recaptchaId), "Content-Type": "multipart/form-data" } });

            GTagHelper.sendEvent("form_submit", "work_with_us");

            this.isSuccess = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset(this.recaptchaId);
        }

        this.isLoading = false;
    }

    public getWidgetId(elementId: string): number {
        const recaptchaBoxes = document.querySelectorAll('.g-recaptcha');
        const targetBox = document.querySelector(`#${elementId}`);
        for (let i = 0; i < recaptchaBoxes.length; i++) {
            if (recaptchaBoxes[i].id === targetBox.id) {
                return i;
            }
        }
        return 0;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};